import { Capacitor } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'

import { Logger } from '../logger'

const logger = new Logger('PushNotificationPermissions')

export class PushNotificationPermissions {
  public async check() {
    try {
      if (Capacitor.getPlatform() === 'web') {
        logger.info('Skipping permission check on web platform')
        return { granted: false, denied: false, prompt: false }
      }

      const permStatus = await PushNotifications.checkPermissions()
      const result = {
        granted: permStatus.receive === 'granted',
        denied: permStatus.receive === 'denied',
        prompt: permStatus.receive === 'prompt',
      }
      logger.info('Permission status', { raw: permStatus.receive, ...result })
      return result
    } catch (error) {
      logger.error('Error checking permissions', error)
      return { granted: false, denied: false, prompt: false }
    }
  }

  public async request() {
    try {
      const previousPermissionStatus = await this.check()

      if (previousPermissionStatus.granted) {
        logger.info('Permission already granted, skipping request')
        return previousPermissionStatus
      }

      if (previousPermissionStatus.denied) {
        logger.warn('Permission previously denied, skipping request')
        return previousPermissionStatus
      }

      if (Capacitor.getPlatform() === 'web') {
        logger.info('Skipping permission request on web platform')
        return previousPermissionStatus
      }

      logger.info('Requesting push notification permission...')
      const newPermissionStatus = await PushNotifications.requestPermissions()
      const result = {
        granted: newPermissionStatus.receive === 'granted',
        denied: newPermissionStatus.receive === 'denied',
        prompt: newPermissionStatus.receive === 'prompt',
      }
      logger.info('Permission request result', { raw: newPermissionStatus.receive, ...result })
      return result
    } catch (error) {
      logger.error('Error requesting permissions', error)
      return { granted: false, denied: false, prompt: false }
    }
  }

  public async register() {
    if (Capacitor.getPlatform() === 'web') {
      logger.info('Skipping registration on web platform')
      return
    }
    logger.info('Registering for push notifications...')
    await PushNotifications.register()
    logger.success('Registered for push notifications')
  }
}
